// A dónde va el "Agregar" de una foto del chat —
// ADR-2026-10-17-el-agregar-del-chat-va-a-la-caja-de-crear.
//
// Por defecto la foto se engancha al composer del chat (`chat.addAttachment`). Pero en la
// conversación del Asistente de Crear la caja que se ve es la de Crear, no la del chat: la
// foto entraba a unos adjuntos invisibles y el botón parecía no hacer nada. Mientras esa
// caja es la de la conversación, Crear registra acá su `agregar` y las cards lo usan en
// lugar del composer. Mismo patrón (módulo suelto, no contexto) que `visorDelLienzo.ts`.

import { useSyncExternalStore } from 'react';
import type { ChatAttachment } from './agentAttachments';

export type AgregarDelChat = (adjunto: ChatAttachment, origen?: { rect: DOMRect; src: string }) => void;

let agregar: AgregarDelChat | null = null;
const oyentes = new Set<() => void>();

export function registrarAgregarDelChat(a: AgregarDelChat | null): void {
  if (agregar === a) return;
  agregar = a;
  for (const o of oyentes) o();
}

export const leerAgregarDelChat = (): AgregarDelChat | null => agregar;

function suscribir(o: () => void): () => void {
  oyentes.add(o);
  return () => {
    oyentes.delete(o);
  };
}

/** El `agregar` de la pantalla que se quedó con la foto del chat, o `null` (va al composer). */
export function useAgregarDelChat(): AgregarDelChat | null {
  return useSyncExternalStore(suscribir, leerAgregarDelChat, () => null);
}
